import { Loading, MessageBox } from 'element-ui';
import _ from 'lodash';
import router from '../../../router';

let isLoginAlertShown = false;
let loading = null;
// loading加载时间
let needLoadingRequestCount = 0;
// 开启loading状态
const startLoading = (headers = {}) => {
  loading = Loading.service({
    target: headers.target || 'body',
    lock: true,
    text: '加载中......',
    background: 'hsla(0, 0%, 100%, .9)',
    text: '拼命加载中',
    fullscreen: true,
  });
};
// 关闭loading状态
const endLoading = _.debounce(() => {
  loading.close();
  // loading = null;
}, 300);
export const showFullScreenLoading = (headers) => {
  if (needLoadingRequestCount == 0) {
    startLoading(headers);
  }
  needLoadingRequestCount++;
};
export const tryHideFullScreenLoading = () => {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0);
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
};
// 超时提示
export function timeOutScreenLoading () {
  setTimeout(() => {
    MessageBox.confirm('请求超时, 是否重新加载?', '提示', {
      confirmButtonText: '刷新',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      console.log('刷新了');
      window.location.reload();
    }).catch(() => {
      tryHideFullScreenLoading();
    });
  }, 8000);
}
// 登录过期
export function toLogin () {
  if (isLoginAlertShown) return;
  isLoginAlertShown = true;

  MessageBox.alert('登录状态已过期，请重新登陆', '提示', {
    confirmButtonText: '确定',
    callback: () => {
      isLoginAlertShown = false;
      router.push('/');
    },
  });
}
export default {};



// WEBPACK FOOTER //
// ./src/assets/plugin/loading/loading.js